<script setup lang="ts">
import { VSheet } from 'vuetify/components'
</script>
<template>
  <Transition name="slide" mode="out-in">
    <v-sheet v-if="$attrs['modelValue']" class="flyout" v-bind="$attrs">
      <slot />
    </v-sheet>
  </Transition>
</template>
<style scoped lang="scss">
.flyout {
  background-color: rgb(var(--v-theme-white));
  height: 100vh;
  position: absolute;
  transition: right 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  right: 0;
  z-index: 5;
  &[from-left] {
    right: unset;
    left: 0;
  }
  &[from-bottom],
  &[from-top] {
    top: 0;
    right: unset;
    left: unset;
    bottom: unset;
  }
  &[aligned-left] {
    left: 0;
  }
  &[aligned-right] {
    right: 0;
  }
}
.close-flyout-button {
  position: absolute;
  left: 15px;
  top: 20px;
}
.slide-enter-active {
  transition: transform 0.5s cubic-bezier(0.52, 0.49, 0, 1.09);
}
.slide-leave-active {
  transition: transform 0.5s cubic-bezier(0.52, 0.49, 0, 1.09);
}
.flyout:not([from-left]) {
  &.slide-enter-from,
  &.slide-leave-to {
    transform: translateX(100%);
    // opacity: 0;
  }
}
.flyout[from-left] {
  &.slide-enter-from,
  &.slide-leave-to {
    transform: translateX(-100%);
    // opacity: 0;
  }
}
.flyout[from-bottom] {
  &.slide-enter-from,
  &.slide-leave-to {
    transform: translateY(100%);
    // opacity: 0;
  }
}
.flyout[from-top] {
  &.slide-enter-from,
  &.slide-leave-to {
    transform: translateY(-10%);
    // opacity: 0;
  }
}
</style>
